<template>
  <div class="widthContent">
    <PageBanner url="https://www.yueyilan.com/img-yueyilan/upload/photo/zsyf/xinwen.png" title="新闻中心"/>
    <router-view></router-view>
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner'
export default {
  name: 'index',
  components:{
    PageBanner
  }
}
</script>





// WEBPACK FOOTER //
// src/components/News/index.vue